import {DashboardButton} from "@/ReactInit/Scripts/DashboardPage/components/DashboardButton";
import {scrollToId} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardScroll";
import {type ScrollToIdOptions} from "@/ReactInit/Scripts/DashboardPage/types";
import {useEffect} from "react";

interface ReportSuccessViewProps {
  onGoToReportHistory: () => void;
}

const ReportSuccessView: React.FC<ReportSuccessViewProps> = (
  {
    onGoToReportHistory,
  }) => {
  useEffect(() => {
    scrollToId("report-finished", {behavior: "smooth", block: "center",} as ScrollToIdOptions);
  });
  return (
    <div id="report-finished" className="flex flex-col gap-20 py-10 tablet:flex-row justify-between items-center">
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          <h2 className="text-5xl font-semibold leading-tight">
            Takk for innsendingen
          </h2>
          <p className="text-xl">Rapporten din ble sendt inn vellykket.</p>
        </div>
        <DashboardButton
          variant="darkplain"
          onClick={onGoToReportHistory}
          label="Gå til rapporthistorikk"
          width="fit"
          rounded="full"
          className="min-h-[54px] items-center"
        />
      </div>

      <img
        src="/img/banana.svg"
        alt=""
        aria-hidden="true"
        className="h-auto opacity-75 w-[380px]"
      />
    </div>
  );
};

export default ReportSuccessView;